import React from 'react';
import RichTextRenderer from '../common/RichTextRenderer';

/**
 * LessonContentView Component
 * Displays lesson content with optional review banner
 *
 * @param {Object} props
 * @param {boolean} props.isViewingBackwards - Whether user is reviewing previous content
 * @param {Function} props.getDisplayedContentLocal - Get currently displayed content
 */
const LessonContentView = ({ isViewingBackwards, getDisplayedContentLocal }) => {
  return (
    <div>
      {isViewingBackwards && (
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg mb-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 text-sm font-semibold">👁</span>
              </div>
            </div>
            <div className="ml-3">
              <h4 className="text-blue-800 font-semibold">Reviewing Previous Lesson</h4>
              <p className="text-blue-700 text-sm">You are viewing a previous lesson.</p>
            </div>
          </div>
        </div>
      )}
      <RichTextRenderer
        content={getDisplayedContentLocal().content}
        className="text-[#1e2d40] lesson-content"
        fontSize="16px"
        lineHeight="1.7"
        allowInlineStyles={true}
      />
    </div>
  );
};

export default LessonContentView;
